import * as React from 'react';
import style from './MemberLabels.scss';
import { CustomLabel } from './CustomLabel';
import {
  LABEL_TYPES,
  TypeLabel,
} from '../../../NewSearchBox/SearchResults/TypeLabel';
import { useCustomLabelsHook } from '../../../../customHooks/useCustomLabelsHook';

export const MemberLabels = ({ customLabels, deprecated }) => {
  const labels = useCustomLabelsHook(customLabels);

  return (
    <div className={style.labelsContainer}>
      {deprecated && (
        <TypeLabel
          type={LABEL_TYPES.DEPRECATED}
          dataHook="deprecated"
          className={style.memberDocsLabel}
        />
      )}
      {labels.map((label) => (
        <CustomLabel
          key={label.name}
          {...label}
          className={style.memberDocsLabel}
        />
      ))}
    </div>
  );
};
